new MutationObserver(() => {
    document.querySelectorAll('img').forEach(el => {
        if (!el.hasAttribute('alt')) {
            el.setAttribute('alt', '')
        }
    });
    document.querySelectorAll('#upCart').forEach(el => {
        el.setAttribute('role', 'region');
        el.setAttribute('aria-label', 'upcart');
    });
}).observe(document.body, { childList: true, subtree: true });

document.querySelectorAll('img').forEach(el => {
        if (!el.hasAttribute('alt')) {
            el.setAttribute('alt', '')
        }
    });
document.querySelectorAll('#upCart').forEach(el => {
    el.setAttribute('role', 'region');
    el.setAttribute('aria-label', 'upcart');
});
